class GoogleMapController {
    constructor($scope, $element) {
        this.$scope = $scope;
        this.mapEl = $element.find('.googleMap-canvas')[0];
        this.map = new google.maps.Map(this.mapEl, this.mapOptions || {});

        setTimeout(() => this.addListeners());

        $scope.$watch(
            () => this.mapOptions,
            () => this.map.setOptions(this.mapOptions),
            true,
        );
    }

    addListeners() {
        if (this.onIdle) {
            this.map.addListener('idle', () => this.$scope.$apply(() => this.onIdle()));
        }

        if (this.onZoomChanged) {
            this.map.addListener('zoom_changed', () => this.$scope.$apply(() => this.onZoomChanged()));
        }
    }

    triggerResize() {
        google.maps.event.trigger(this.map, 'resize');
    }

    getMap() {
        return this.map;
    }
}

const googleMapDirectiveDefinition = () => ({
    restrict: 'E',
    scope: {},
    bindToController: {
        map: '=?',
        mapOptions: '=',
        mapStyle: '=?',
        onIdle: '&?',
        onZoomChanged: '&?',
    },
    controller: ['$scope', '$element', GoogleMapController],
    controllerAs: 'googleMapCtrl',
    transclude: true,
    template: '<div ng-style="googleMapCtrl.mapStyle" class="googleMap-canvas"></div><ng-transclude></ng-transclude>',
});

module.exports = {
    GoogleMapController,
    googleMapDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/google-map.directive.js